// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import PrivacyModalController from "./privacy_modal_controller"
application.register("privacy-modal", PrivacyModalController)
